import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { CardService } from '../../services/card.service';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { OrderService } from 'app/modules/order/services/order.service';
import { ToastrService } from 'ngx-toastr';

import Swal from "sweetalert2";
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { Constants } from 'app/shared/constant/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from 'app/shared/utility/date-utils';
import { UpdateProfileModel } from 'app/modules/update-profile/models/update-profile.model';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';

@Component({
    selector: 'cards',
    templateUrl: './card-list.component.html',
    styleUrls: ['./card-list.component.scss'],
    // encapsulation: ViewEncapsulation.None
  })
  export class CardListComponent implements OnInit {

  public showLoader: boolean = false;
  public reqCurrencyAmount: any;
  public previousUrl: string = "";
  public consumerData: any;
  public isSmartCardAvl: boolean = false;
  public isStudentPayAvl: boolean = false;
  public isTravelPayAvl: boolean = false;
  public isGlobalPayAvl: boolean = false;
  public isXplorerCardAvl: boolean = false;
  public isSwitchCardAvl: boolean = false;
  public isUniZCardAvl: boolean = false;
  public vcipAccepted: any;
  public isVcipComplete: boolean = false;
  isPANCBChecked: boolean = false;
  public paxId: any;
  public consumerDetail: any;
  public isProfileComplete: boolean = false;
  public signature: any;
  @ViewChild("PANDetailModal") PANDetailModal: TemplateRef<any>;

  public isApplyForCard: boolean = false;
  public allCard: any;
  public cards;
  public isGlobalPayMultiAvl: boolean = false;
  public explorerStataData: any;
  public modalReference: any; 
  public vcipStatusDetails: any;  
  public vcipMessage: any; 
  public showButtonOnVCIP: boolean = false;
  public xplorerVcipMessage: string = '';
  public xplorerVcipTitle: string = '';

  isVCIPNow: boolean = false;
  public isOrderWithoutVcipComplete: boolean = false;
  public isPANAvailable: boolean = false;
  panVerificationErrMsg: string;

  public updateProfileModel = new UpdateProfileModel();
  @ViewChild("errorModal") errorModal: TemplateRef<any>;
  @ViewChild("vcipModalNewUser") vcipModalNewUser: TemplateRef<any>;

  @ViewChild(SwiperComponent) cardListRef: SwiperComponent;
  @ViewChild("cardRegistrationIn") cardRegistrationIn: TemplateRef<any>;    

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    // autoHeight: true,
    slidesPerView: 2,
    keyboard: false,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: false,
    centeredSlides: true,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        centeredSlides: false,
        // spaceBetween: 20
      },
      480: {
        slidesPerView: 1.2,
      spaceBetween: 20,
        centeredSlides: false,
      },
      640: {
        slidesPerView: 4.3,
        scrollbar: true, 
        mousewheel: false,
        centeredSlides: false,
        spaceBetween: 1
      }
    }
  };

  public isSwitchCardVisible: string = 'false';
  public configData;

  constructor(
    private masterDataService: MasterDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cardService: CardService,
    private profileService: UpdateProfileService,
    private orderService: OrderService,
    public toast: ToastrService,
    public gtmPushService: GTMDataLayerService,
    public updateProfileService: UpdateProfileService,
    private modalService: NgbModal) {
  }

  ngOnInit() {
    this.getLocalData();
    this.getAllCardDetails();
    this.getExplorersStatus();  
    this.getProfileDetails();
    this.getVCIPStatus();  
    this.cards = Constants.cardData;
  }

  getLocalData() {
    var consumerDataLocal = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    this.consumerData = JSON.parse(consumerDataLocal);
    console.log("this.consumerData ", this.consumerData);
    console.log("this.consumerData ", this.consumerData);
    let configData:any = localStorage.getItem(ConstantsKey.CONFIG_CORE_DATA);
    if(configData) {
      configData = JSON.parse(configData);
      console.log("CONFIG --------------------------- ", this.configData);
      configData = configData.filter(data => data.key == 'show_switch_card');
      if(configData.length == 1) {
        this.isSwitchCardVisible = (configData)[0].value;
      }
    }
  }

  getSessionData() {

  }


  cardBuy(cardType) {
    //sessionStorage.setItem(ConstantsKey.MY_CARD_CHOOSE, cardType);
    sessionStorage.setItem(ConstantsKey.CART_ORDER_TYPE, 'CARD_PURCHASE');
    let card = this.cards.filter(obj => obj.card == cardType)[0];
    sessionStorage.setItem(ConstantsKey.WSFX_SELECTED_CARDS, JSON.stringify(card));
    sessionStorage.setItem(ConstantsKey.IS_CARD_BUY_FROM_CARDS_PAGE, "YES")
    this.router.navigate(['/newcard']);
  }

  goToLinkExistingCard(cardType) {
    let card = this.cards.filter(obj => obj.card == cardType)[0];
    sessionStorage.setItem(ConstantsKey.WSFX_SELECTED_CARDS, JSON.stringify(card));
    if(cardType == 'SMART_CARD') {
      this.router.navigate(['/link-existing-card']);
    } else if(cardType == 'STUDENT_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'TRAVEL_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'GLOBAL_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'GLOBAL_MULTI_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'XPLORER_MULTI_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'GLOBAL_SWITCH_CARD') {
      this.router.navigate(['/link-forex-card']);
    } else if(cardType == 'UNI_Z_CARD') {
      this.router.navigate(['/link-forex-card']);
    }
  }

  goToMyCard(cardType) {
    //sessionStorage.setItem(ConstantsKey.MY_CARD_CHOOSE, cardType);    
    let card = this.cards.filter(obj => obj.card == cardType)[0];
    sessionStorage.setItem(ConstantsKey.WSFX_SELECTED_CARDS, JSON.stringify(card));
    this.router.navigate(['/my-card']);
  }

  goToFeatures(cardType) {
    if(cardType == 'SMART_CARD') {
      this.router.navigate(['/my-features']);
    } else if(cardType == 'STUDENT_CARD') {
      this.router.navigate(['/newfeatures']);
    } else if(cardType == 'TRAVEL_CARD') {
      this.router.navigate(['/travelpay-features']);
    } else if(cardType == 'GLOBAL_CARD') {
      this.router.navigate(['/globalpay-features']);
    } else if(cardType == 'GLOBAL_MULTI_CARD') {
      this.router.navigate(['/global-multi-features']);
    } else if(cardType == 'XPLORE_CARD') {
      this.router.navigate(['/xplorer-feature']);
    } else if(cardType == 'GLOBAL_SWITCH_CARD') {
      this.router.navigate(['/features/', 'switch-card']);
    } else if(cardType == 'UNI_Z_CARD') {
      this.router.navigate(['/features/', 'uni-z-card']);
    }
  }


  getAllCardDetails() {
    this.showLoader = true;
    this.cardService.getAllCardDetail().subscribe(resp => {
      this.showLoader = false;
      let smartCard = false;

      this.allCard = resp.body;
      if(this.allCard.length > 0) {
          for(let i=0 ;i < this.allCard.length ;i++) {
            if(this.allCard[i].cardVendor == 'WSFLMCC') {
              smartCard = true;
              this.isSmartCardAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXSTUDENTSCC') {
              this.isStudentPayAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXTRAVELSCC') {
              this.isTravelPayAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXGLOBALMCC' || this.allCard[i].cardVendor == 'WSFXGLOBALSCC') {
              this.isGlobalPayAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXGPMCC') {
              this.isGlobalPayMultiAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXXPMCC') {
              this.isXplorerCardAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXSWITCHMCC') {
              this.isSwitchCardAvl = true;
            } else if(this.allCard[i].cardVendor == 'WSFXUNIMCC') {
              this.isUniZCardAvl = true;
            }


          }
          //If card not foudn in smart card
          if(!smartCard) {
            this.getCardDetails();
          }          
      } else {
        this.showLoader = false;
        this.getCardDetails();
      }

    },
    errObj =>  {
      this.toast.error(errObj.error.message);
    });
  }

 
  getCardDetails() {
    //this.showLoaderForCardDetails = true;

    this.cardService.getCardDetails().subscribe((respCardData => {
      var responseBody = JSON.parse(JSON.stringify(respCardData.body));
      if (responseBody.length > 0) {
        this.isSmartCardAvl = true;
      }
    }), error => {
      //this.showLoaderForCardDetails = false;
    });;
   }

   openModalForVCIPNewUser() {
    this.modalReference = this.modalService.open(this.vcipModalNewUser, {
      centered: true,
      size: 'md',
    });
  }

   public onIndexChange(index: number) {
    console.log('Swiper index: ', index);
  }


    getExplorersStatus() {
      this.cardService.getExplorersStatus(this.consumerData["mobile"]).subscribe(resp => {
        this.explorerStataData = resp.body;
      }, err => {
      });
    }    

    viewStatus() {
      this.modalReference = this.modalService.open(this.cardRegistrationIn, {centered: true,size: "md",});
    }


  goToActivateXploreCard() {
    localStorage.setItem(ConstantsKey.XPLORER_CARD_DATA, JSON.stringify(this.explorerStataData));
    sessionStorage.removeItem(ConstantsKey.IS_XPLORER_CARD_CALC);
    sessionStorage.removeItem(ConstantsKey.IS_XPLORER_AMT_ADDED);
    this.router.navigate(['/xplorer-card-activation-form']);
  }

  goToExplorerRegister() {
    this.router.navigate(['/xplorer-card-request']);    
  }

  smartCardDisabledPopup() {
    Swal.fire({
      title: "Dear Customer",
      html: "The Smart Currency Card programme with YES Bank ended on 30 September 2026. If your card has a remaining balance, please visit your nearest YES Bank branch to encash it. Please carry your card and a valid KYC documents. For further assistance, please call 1800 267 3899 or email wsfxsmarcard@yes.bank.in.",
      imageUrl: "assets/images/icons/info_icon.png",
      imageWidth: 80,
      imageHeight: 80,
      focusConfirm: false,
      confirmButtonColor: "#080808",
    });
  }

  getVCIPStatus(onComplete?: () => void) {
    this.showLoader = true;
    this.updateProfileService.getVCIPStaus().subscribe((resp => {
      this.showLoader = false;
      this.vcipStatusDetails = resp.body;
      this.vcipMessage = this.vcipStatusDetails.message;
      this.showButtonOnVCIP = this.vcipStatusDetails.showBtnOnStatus;
      this.xplorerVcipMessage = this.getXplorerVcipStatusMessage();
      if (this.vcipStatusDetails.vcipStatus == 'ACCEPTED') {
        this.vcipAccepted = true;
      } else {
        this.vcipAccepted = false;
        if(this.vcipStatusDetails.vcipStatus == 'NOT_INITIATED' || this.vcipStatusDetails.vcipStatus == 'INITIATED' ||   this.vcipStatusDetails?.vcipStatus == 'IN_PROGRESS'){
            this.xplorerVcipMessage=' A quick video call is needed to verify your identity. It takes just a few minutes. Please keep your original PAN card ready.';
            this.xplorerVcipTitle='Complete your Video KYC';
        }else if(this.vcipStatusDetails.vcipStatus == 'PENDING'){
            this.xplorerVcipMessage="Thank you! We've received your details and are verifying them. We'll notify you once it's done.";
            this.xplorerVcipTitle='Your Video KYC is under review';
        }else if(this.vcipStatusDetails.vcipStatus == 'REJECTED'){
           this.xplorerVcipMessage="We couldn't verify your details this time. Please try again with good lighting, a stable internet connection, and your original PAN card.";
            this.xplorerVcipTitle='Video KYC unsuccessful';

        }
      }
      onComplete?.();
    }), error => {
      this.showLoader = false;
      onComplete?.();
    });
  }

   getProfileDetails() {
    this.profileService.getProfileListAll().subscribe(
      (resp) => {
        this.showLoader = false;
        this.consumerDetail = resp.body;

        this.isProfileComplete =
          this.consumerDetail.paxResponse?.profileComplete;
        this.isVcipComplete = this.consumerDetail?.vcipKyc;
        this.paxId = this.consumerDetail.paxResponse.id;
        localStorage.setItem(
          ConstantsKey.PAXID,
          this.consumerDetail.paxResponse.id
        );

        if (this.consumerDetail?.paxResponse?.consumer?.vcipSkipAllowed) {
          this.isVcipComplete = true;
        } else if (
          this.consumerDetail?.paxResponse?.consumer?.offlineonboarding == "1"
        ) {
          this.isVcipComplete = true;
        }
        if (!this.isVcipComplete) {
          this.getVCIPStatus();
        } else {
          localStorage.setItem(
            ConstantsKey.IS_VCIP_COMPLETE,
            this.isVcipComplete.toString()
          );
        }
        if (
          this.consumerDetail?.paxResponse != null &&
          this.consumerDetail?.paxResponse?.pan
        ) {
          this.isPANAvailable = true;
        }
        this.signature = this.consumerDetail.signature;

        if (this.signature == undefined) {
          this.isProfileComplete = false;
        }
        localStorage.setItem(ConstantsKey.CONSUMER_SIGNATURE, this.signature);
        if (this.consumerDetail?.paxResponse?.pan) {
          localStorage.setItem(
            ConstantsKey.CONSUMER_PAN,
            this.consumerDetail?.paxResponse?.pan
          );
        }
      },
      (error) => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      }
    );
  }

   getXplorerVcipStatusState(status?: string): { allowLink: boolean; showAction: boolean; message: string } {
    const vcipStatus = (status || this.vcipStatusDetails?.vcipStatus || '').toUpperCase();
    const defaultMessage = this.vcipStatusDetails?.message || 'Please complete your Video-KYC';

    const states = {
      ACCEPTED: { allowLink: true, showAction: false, message: '' },
      NOT_INITIATED: { allowLink: false, showAction: true, message: defaultMessage },
      INITIATED: { allowLink: false, showAction: true, message: defaultMessage },
      IN_PROGRESS: { allowLink: false, showAction: true, message: defaultMessage },
      PENDING: { allowLink: false, showAction: true, message: defaultMessage },
      REJECTED: { allowLink: false, showAction: true, message: 'Your Video-KYC was not successful. Please re-attempt to continue.' },
      DRAFT: { allowLink: false, showAction: true, message: defaultMessage },
    } as const;

    return states[vcipStatus as keyof typeof states] || {
      allowLink: false,
      showAction: true,
      message: defaultMessage,
    };
  }

  getXplorerVcipStatusMessage(status?: string): string {
    return this.getXplorerVcipStatusState(status).message;
  }

  

  checkXplorerLinkEligibility() {
    this.getVCIPStatus(() => this.handleXplorerLinkEligibility());
  }

  handleXplorerLinkEligibility() {
    const status = (this.vcipStatusDetails?.vcipStatus || '').toUpperCase();

    if (status === 'ACCEPTED' || !status) {
      this.goToLinkExistingCard('XPLORER_MULTI_CARD');
      return;
    }

    const state = this.getXplorerVcipStatusState();
    if (state.allowLink) {
      this.goToLinkExistingCard('XPLORER_MULTI_CARD');
      return;
    }

    this.openModalForVCIPNewUser();
  }

  shouldShowVcipActionButton(): boolean {
    return this.getXplorerVcipStatusState().showAction;
  }

  getXplorerVcipActionLabel(): string {
    const status = (this.vcipStatusDetails?.vcipStatus || '').toUpperCase();
     if (status === 'NOT_INITIATED' || status === 'INITIATED' ||  status == 'IN_PROGRESS') {
        return 'Start Video KYC';
      } else if (status === 'REJECTED') {
        return 'Retry Video KYC';
      }
      return 'Okay';
  }

   initiateVcip() {
    this.modalReference.close();
    if(this.vcipStatusDetails?.vcipStatus=='NOT_INITIATED' || this.vcipStatusDetails?.vcipStatus=='REJECTED' || this.vcipStatusDetails?.vcipStatus=='INITIATED' ||   this.vcipStatusDetails?.vcipStatus == 'IN_PROGRESS'){
          if (!this.isPANAvailable) {
            this.modalReference = this.modalService.open(this.PANDetailModal, {
              centered: true,
              size: "sm",
            });
            return;
          }else{
          this.updateProfileService.getVCIPRedirectionURL().subscribe(
            (resp) => {
              this.showLoader = false;
              var vcipResponse = JSON.parse(JSON.stringify(resp.body));
              let vcipUrl = vcipResponse.mobileAutologinUrl;
              window.open(vcipUrl, "_blank");
            },
            (error) => {
              this.showLoader = false;
              this.toast.error(JSON.stringify(error.error.message));
            }
          );
        }
    }
  }


  
  openModalForPANNo() {
    this.modalReference.close();
    this.modalReference = this.modalService.open(this.PANDetailModal, {
      centered: true,
      size: "sm",
    });
  }

   getPanName() {
    this.updateProfileModel.pan = this.updateProfileModel.pan.toUpperCase();
    if (
      this.updateProfileModel.pan &&
      this.updateProfileModel.pan.length == 10 &&
      this.validatePANNo(this.updateProfileModel.pan)
    ) {
      this.showLoader = true;
      this.updateProfileService
        .getPANName(this.updateProfileModel.pan)
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              if (
                panResponse.fullName &&
                panResponse.fullName != "null" &&
                panResponse.fullName != ""
              ) {
                this.updateProfileModel.name = panResponse.fullName;
              } else {
                this.updateProfileModel.name = "";
              }

              if (
                panResponse.dob &&
                panResponse.dob != "null" &&
                panResponse.dob != ""
              ) {
                this.updateProfileModel.dob =
                  DateUtils.ngbDateStructDateConverter(panResponse.dob);
              }
            } else if (
              panResponse.flatPan.status ==
              "Record Not Found in ITD Database/Invalid PAN"
            ) {
              this.updateProfileModel.name = "";
              this.updateProfileModel.dob = "";
              this.toast.error("Invalid Pan");
            } /* else {
          this.toast.error(panResponse.flatPan.status);
        } */
          },
          (error) => {
            this.showLoader = false;
            this.updateProfileModel.name = "";
            // this.updateProfileModel.dob = '';
            this.toast.error(error.error.message);
          }
        );
    }
  }

    updatePAN() {
    this.showLoader = true;
    this.updateProfileModel.mobile = this.consumerDetail?.mobile;
    this.updateProfileModel.email = this.consumerDetail?.email;
    let dateofBirth = DateUtils.getNgbDateStructToDate(
      this.updateProfileModel.dob
    );
    this.updateProfileModel.dob = dateofBirth;

    this.updateProfileService
      .updateProfileDetails(this.paxId, this.updateProfileModel)
      .subscribe(
        async (resp) => {
          this.showLoader = false;
          console.log(resp.body);
          sessionStorage.setItem("PROCEED-WITHOUT-VCIP-CARD", "true");
          this.modalReference.close();
          //this.proceedToViewCart();
        },
        (error) => {
          this.showLoader = false;
          if (error.status == 200) {
            sessionStorage.setItem("PROCEED-WITHOUT-VCIP-CARD", "true");
            this.showLoader = false;
            this.modalReference.close();
            if (this.isVCIPNow) {
              this.initiateVcip();
            }
            //this.proceedToViewCart();
          } else {
            this.toast.error("Something went wrong ! Please try again !");
          }
        }
      );
  }

   openErrorModal() {
    this.modalReference = this.modalService.open(this.errorModal, {
      centered: true,
      size: "sm",
    });
  }

   validatePanAPI() {
    if (this.validatePanDetails()) {
      this.showLoader = true;
      let dateofBirth = DateUtils.getNgbDateStructToDatev2(
        this.updateProfileModel.dob
      );

      this.profileService
        .validatePAN(
          this.updateProfileModel.pan,
          this.updateProfileModel.name,
          dateofBirth
        )
        .subscribe(
          async (resp) => {
            console.log(resp.body);
            let isPanSuccess;
            var panResponse = JSON.parse(JSON.stringify(resp.body));
            this.showLoader = false;
            if (panResponse.panStatus == "E") {
              // && panResponse.fullName != "" && panResponse.dob != ""
              isPanSuccess = 'Yes';
              this.updatePAN();
            } else if (panResponse.panStatus != "E") {
              this.panVerificationErrMsg = "Please enter valid PAN";
              isPanSuccess = 'No';              
              this.openErrorModal();
            } 

            let gtmObj = {
              event: "pan_Verification",
              verfication_success: isPanSuccess == 'Yes' ? 'Yes' : 'No' ,
              verfication_failed: isPanSuccess == 'No' ? 'Yes' : 'No',
              later: 'Y',
              mobile: "91"+this.consumerDetail.mobile,
              email: this.consumerDetail.email,
            };
            this.gtmPushService.dataLayerPushData(gtmObj);

          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
    }
  }

validatePANNo(panNo) {
    const regex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
    if (!regex.test(panNo)) {
      return false;
    } else {
      return true;
    }
  }

  validatePanDetails() {
    if (!(this.updateProfileModel.pan != null)) {
      this.toast.error("Please enter your PAN");
      return false;
    }
    if (!this.validatePANNo(this.updateProfileModel.pan)) {
      this.toast.error("Please enter valid PAN");
      return false;
    }
    if (!(this.updateProfileModel.name != null)) {
      this.toast.error("Please enter name as per PAN");
      return false;
    }
    if (!this.isPANCBChecked) {
      this.toast.error("Please check the declaration of PAN");
      return false;
    }
    if (!(this.updateProfileModel.dob != null)) {
      this.toast.error("Please select your Date of Birth ");
      return false;
    }

    return true;
  }

  alphaNumberOnly(e) {
    // Accept only alpha numerics, not special characters
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }

   

}